import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ConfigService } from '../../Core/Config/services/config.service';
import { ServiceApi } from '../genericApi/service-api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { EmailAccountConnectorConfigApi } from './models/email-account-connector-config.api';
import { EmailAccountConnectorApi } from './models/email-account-connector.api';

@Injectable()
export class EmailAccountConnectorApiService {

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService,
    ) {}

    /**
     * [ADMIN]
     */
    public getEmailAccountConnectorConfigByAccountId(accountId: number): Observable<EmailAccountConnectorConfigApi> {
        const slug = `/emailaccountconnectors/admin/config/account/${accountId}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<EmailAccountConnectorConfigApi>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );

        return response;
    }

    /**
     * [ADMIN]
     */
    public createEmailAccountConnectorConfig(accountId: number, emailAccountConnectorConfig: EmailAccountConnectorConfigApi): Observable<number> {
        const slug = `/emailaccountconnectors/admin/config/account/${accountId}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<number>(
            slug,
            emailAccountConnectorConfig,
            HttpVerbsEnum.POST
        );

        return response;
    }

    /**
     * [ADMIN]
     */
    updateEmailAccountConnectorConfig(accountId: number, emailAccountConnectorConfig: EmailAccountConnectorConfigApi): Observable<number> {
        const slug = `/emailaccountconnectors/admin/config/account/${accountId}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<number>(
            slug,
            emailAccountConnectorConfig,
            HttpVerbsEnum.PUT
        );
    }

    /**
     * [ADMIN]
     */
    public getByAccountId(accountId: number): Observable<EmailAccountConnectorApi[]> {
        const slug = `/emailaccountconnectors/admin/account/${accountId}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<EmailAccountConnectorApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );

        return response;
    }

    /**
     * Returns the config (limits) for the current user account
     */
    public getEmailAccountConnectorConfig(): Observable<EmailAccountConnectorConfigApi> {
        const slug = '/emailaccountconnectors/config';
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<EmailAccountConnectorConfigApi>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );

        return response;
    }

    public getById(id: number): Observable<EmailAccountConnectorApi> {
        const slug = `/emailaccountconnectors/connector/${id}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<EmailAccountConnectorApi>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );

        return response;
    }

    public updateById(id: number, emailAccountConnector: EmailAccountConnectorApi): Observable<number> {
        const slug = `/emailaccountconnectors/connector/${id}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<number>(
            slug,
            emailAccountConnector,
            HttpVerbsEnum.PUT,
        );

        return response;
    }

    public deleteById(id: number): Observable<number> {
        const slug = `/emailaccountconnectors/connector/${id}`;
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<number>(
            slug,
            null,
            HttpVerbsEnum.DELETE,
        );

        return response;
    }

    public getAll(): Observable<EmailAccountConnectorApi[]> {
        const slug = '/emailaccountconnectors';
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        const response = this.serviceApi.api<EmailAccountConnectorApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );

        return response;
    }

    public buildRedirectUrl(emailAccountConnector: EmailAccountConnectorApi): Observable<string> {
        const slug = '/emailaccountconnectors/auth';
        const response = this.serviceApi.api<string>(
            slug,
            emailAccountConnector,
            HttpVerbsEnum.POST,
            null,
            'text'
        );

        return response;
    }

    public reAuthenticateEmailAccountConnector(emailAccountConnector: EmailAccountConnectorApi, code: string, state: string): Observable<void> {
        const slug = `/emailaccountconnectors/auth/code?code=${code}&state=${state}`;
        const response = this.serviceApi.api<void>(
            slug,
            emailAccountConnector,
            HttpVerbsEnum.POST,
        );

        return response;
    }

    public createEmailAccountConnector(emailAccountConnector: EmailAccountConnectorApi, code: string, state: string): Observable<number> {
        const slug = `/emailaccountconnectors/auth/code?code=${code}&state=${state}`;
        const response = this.serviceApi.api<number>(
            slug,
            emailAccountConnector,
            HttpVerbsEnum.POST,
        );

        return response;
    }
}
